import React from "react";
import { withTheme } from "@rjsf/core";
import validator from "@rjsf/validator-ajv8";
import { Theme } from "@rjsf/mui";
import { Paper, Box, Typography } from "@mui/material";

const Form = withTheme(Theme);

const schema = {
  type: "object",
  properties: {
    minSustainabilityScore: {
      type: ["number", "null"],
      enum: [1, 2, 3, 4, 5],
      title: "Min Sustainability Score - optional"
    },
    searchableModelsFilter: {
      type: "array",
      items: {
        type: "string",
        enum: ["Brands", "Content", "WebflowBlogs"]
      },
      title: "Searchable Models - optional, default is all; if you want just articles, add BOTH WebflowBlogs and Content"
    },
    resultDisplayFlavor: {
      type: "string",
      enum: ["fullWidth", "triptych"],
      title: "Card display in carousel - optional, default is triptych"
    }
  },
  additionalProperties: false
};

const uiSchema = {
  minSustainabilityScore: {
    "ui:widget": "select",
    "ui:placeholder": "(none)"
  },
  "ui:submitButtonOptions": { norender: true }
};

export const SearchOptionsInput = ({ searchOptions = {}, onChange }) => {
  const handleChange = (formData) => {
    // Clean up the form data to remove empty/default values
    const cleanedData = { ...formData };

    // Remove minSustainabilityScore if it's null or undefined
    if (cleanedData.minSustainabilityScore === null || cleanedData.minSustainabilityScore === undefined) {
      delete cleanedData.minSustainabilityScore;
    }

    // Remove searchableModelsFilter if it's empty array
    if (cleanedData.searchableModelsFilter && cleanedData.searchableModelsFilter.length === 0) {
      delete cleanedData.searchableModelsFilter;
    }

    // Remove resultDisplayFlavor if it's empty or undefined
    if (!cleanedData.resultDisplayFlavor || cleanedData.resultDisplayFlavor === "") {
      delete cleanedData.resultDisplayFlavor;
    }

    // Only call onChange if there are actual values, otherwise pass empty object
    onChange(Object.keys(cleanedData).length > 0 ? cleanedData : {});
  };

  return (
    <Paper elevation={2} sx={{ p: 2, mb: 2 }}>
      <Box>
        <Typography variant="subtitle1" fontWeight={600}>
          Search Result Options
        </Typography>
      </Box>
      <Form
        schema={schema}
        validator={validator}
        formData={searchOptions}
        onChange={(e) => handleChange(e.formData)}
        uiSchema={uiSchema}
        formComponent={() => <React.Fragment />}
      />
    </Paper>
  );
};
